import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {map} from 'rxjs/operators';
import ErrorStackParser from "error-stack-parser";
import * as StackFrame from "stackframe";
import {AppConfig} from "../app.config";
import {BaseStateService} from "../base-state.service";
import {stringifyJson} from "../helpers/string-helper";

export interface IErrorContext {
  name: string;
  user: string;
  time: Date;
  id: string;
  url: string;
  status?: number;
  type?: string;
  message: string;
  stack: StackFrame[];
}

@Injectable({
  providedIn: 'root'
})
export class ServerLoggerService {

  constructor(private http: HttpClient, private locationStrategy: LocationStrategy, private stateService: BaseStateService) {
  }

  public log(error: any): Observable<IErrorContext> {
    return this.getErrorContextInfo(error).pipe(map(value => {
      if (error.cause != 'DynamicComponent') {
        this.http
          .post(
            'api/config/PostClientError',
            stringifyJson(value)
          )
          .subscribe({
            next: value1 => true,
            error: error1 => console.error('Error is posting error', error1)
          });
      }
      return value;
    }));
  }

  getErrorContextInfo(error: Error | HttpErrorResponse) {
    // All the context details that you want (usually coming from other services; Constants, UserService...)
    return this.stateService.currentUser$.pipe(map(value => {
      if (localStorage.getItem('Context-Info-Debugging') != 'false') {
        debugger
      }
      const name = error.name || null;
      const user = value?.Email;
      const time = new Date();
      const id = `${user}-${time.getTime()}`;
      const location = this.locationStrategy;
      const url = location instanceof PathLocationStrategy ? location.path() : '';
      const status = error instanceof HttpErrorResponse ? error.status : null;
      const type = error['errorType'];
      const message = error.message || error.toString();
      const stack = (error instanceof HttpErrorResponse ? [] : [error].map(ErrorStackParser.parse, ErrorStackParser)[0]).filter((value1, index) => index < 2);
      return {name, user, time, id, url, status, message, stack, type} as IErrorContext;
    }));
  }
}
